import desclaimerTemplate from '../../templates/dialog/RDTheme/disclaimer_template.ejs'
import desclaimerConfirmTemplate from '../../templates/dialog/RDTheme/disclaimer_confirm_template.ejs'

import desclaimerRDPlusThemeTemplate from '../../templates/dialog/RDPlusTheme/disclaimer_template.ejs'
import desclaimerConfirmRDPlusThemeTemplate from '../../templates/dialog/RDPlusTheme/disclaimer_confirm_template.ejs'

const importDesclaimerOverlaySheetTemplateFactory = (options = {}) => {
    if (ApexChat.IsRoundedDynamicPlusTheme) {
        return {
            desclaimerTemplate: desclaimerRDPlusThemeTemplate(options),
            desclaimerConfirmTemplate: desclaimerConfirmRDPlusThemeTemplate(options),
        }
    }
    return {
        desclaimerTemplate: desclaimerTemplate(options),
        desclaimerConfirmTemplate: desclaimerConfirmTemplate(options),
    }
};
export default importDesclaimerOverlaySheetTemplateFactory;
